import Tooltip from '../../../ui/Tooltip';
import IconInfo from '../../icon/IconInfo';
import React from 'react';

export default function FooterSectionTooltip() {
  return (
    <Tooltip
      content="This section is always at the bottom of the form and its title (&apos;Footer&apos;) is invisible"
      label="footerTip" className="pl-0.5">
      <IconInfo className="text-gray-dark "/>
    </Tooltip>
  );
}
